










































import { Component, Vue, Prop, PropSync, Emit, Ref } from "vue-property-decorator";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { saudeAtendimentoService } from "@/service/cadastro/saude/atendimento/SaudeAtendimentoService";
import { RetornoMensagemModel } from "@/models/cadastros/saude/RetornoMensagemModel";
import { ValidationObserver } from "vee-validate";
import { ValidationResult } from "vee-validate/dist/types/types";
import EspecialidadeModel from '@/models/cadastros/saude/EspecialidadeModel';

@Component({
  components: {
    GsModalDialog,
  },
})
export default class ModalAprovarRecusarSolicitacao extends Vue {
  @Prop({ default: "RECUSA" })
  tipo!: string;

  @Prop({ default: -1 })
  idAtendimento!: number;

  @PropSync("exibeModal", { required: true })
  exibeModalSynced!: boolean;
  
  @Prop({default: []})
  especialidades!: EspecialidadeModel[];

  @PropSync("especialidade", {required: false})
  especialidadeSynced!: EspecialidadeModel;
  

  @Prop({ default: false })
  isRemocao!: boolean;

  @Ref()
  readonly justificativaObserver!: InstanceType<typeof ValidationObserver>;

  texto = "";

  get isAprovacao(): boolean {
    return this.tipo == "APROVACAO";
  }

  cancelar() {
    this.exibeModalSynced = false;
     this.justificativaObserver.reset();
  }

  confirmar() {
    this.justificativaObserver.validate().then((valid: boolean) => {
      if (valid) {
        if (this.isAprovacao) {
          saudeAtendimentoService
            .aprovarSolicitacaoOrcamento(this.idAtendimento, this.texto, this.especialidadeSynced.id)
            .then((res: RetornoMensagemModel) => {
              this.exibirMessageDialog("Sucesso", res.mensagem, true);
            })
            .catch((err: Error) => {
              this.exibirMessageDialog("Sucesso", err.message, false);
            });
        } else {
          saudeAtendimentoService
            .recusarSolicitacaoOrcamento(this.idAtendimento, this.texto)
            .then((res: RetornoMensagemModel) => {
              this.exibirMessageDialog("Sucesso", res.mensagem, true);
            })
            .catch((err: Error) => {
              this.exibirMessageDialog("Sucesso", err.message, false);
            });
        }
        this.exibeModalSynced = false;
      }
    });
  }

  @Emit("messageDialog")
  exibirMessageDialog(titulo: string, mensagem: string, sucesso: boolean) {
    return {
      titulo,
      mensagem,
      sucesso,
    };
  }
}
